import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import nnnn from '../assets/images/nnnn.jpg';
function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={nnnn} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Na-bee-n" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/nabin-shrestha-8b746a217/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Nabin Shrestha</h1>
          <p>Computer Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Na-bee-n" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/nabin-shrestha-8b746a217/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;